import { render, staticRenderFns } from "./addSigningPreferential.vue?vue&type=template&id=0065fc8f&scoped=true&"
import script from "./addSigningPreferential.vue?vue&type=script&lang=js&"
export * from "./addSigningPreferential.vue?vue&type=script&lang=js&"
import style0 from "./addSigningPreferential.vue?vue&type=style&index=0&id=0065fc8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0065fc8f",
  null
  
)

export default component.exports